import { render } from "./nonRocComponent.vue?vue&type=template&id=59252f20"
import script from "./nonRocComponent.vue?vue&type=script&lang=js"
export * from "./nonRocComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__